import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../../assets/img/Icons/White/plane.svg'


const _hoisted_1 = { class: "survey-ai--say" }
const _hoisted_2 = { class: "survey-ai--say--avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dot dot-3" }, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "survey-ai--receive" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "survey-ai--receive--answer"
}

import { computed, onMounted, ref } from 'vue'
import type { Ref } from 'vue'
import {
    CurrentAnswer,
    SavedAiQuestion,
    Say,
    SurveyDisplayValues,
    SurveyParams,
    QUESTION_KEY_AI,
} from '@/entities/conversation'
import { getAiQuestion } from '@/api/conversation'

interface Props {
    item: Say
    surveyDisplayValues?: SurveyDisplayValues | unknown
    surveyParams: SurveyParams
    surveyQuestionsAndAnswers: CurrentAnswer[]
    avatarSrc?: string
    isActive: boolean
    isPreview: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationItemSayAI',
  props: {
    item: {},
    surveyDisplayValues: {},
    surveyParams: {},
    surveyQuestionsAndAnswers: {},
    avatarSrc: {},
    isActive: { type: Boolean },
    isPreview: { type: Boolean }
  },
  emits: ['callNext', 'saveAiQuestion'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const aiQuestions: Ref<string[]> = ref([])
const aiAnswers: Ref<string[]> = ref([])
const currentAiLoopIdx = ref(-1)
const currentAiAnswer = ref('')
const maxAiQuestions = computed(() => props.item.aiQuestionCount || 0)
const isFinalAiQuestion = ref(false)
const currentSurveyContext: Ref<CurrentAnswer[]> = ref([])

const isLoading = ref(false)

onMounted(() => {
    if (props.isActive) {
        currentSurveyContext.value = props?.surveyQuestionsAndAnswers || []
        getNextAiQuestion()
    } else {
        if (props.surveyDisplayValues) {
            const savedAIQuestions = props.surveyDisplayValues[
                QUESTION_KEY_AI
            ] as SavedAiQuestion
            if (savedAIQuestions) {
                aiQuestions.value = savedAIQuestions.questions
                aiAnswers.value = savedAIQuestions.answers
            }
        }
    }
})

const getNextAiQuestion = async () => {
    isLoading.value = true
    currentAiLoopIdx.value++
    aiQuestions.value.push('...')

    // immediately save answer to the current AI question
    const answerValue = aiAnswers.value[currentAiLoopIdx.value - 1]
    if (answerValue) {
        emit(
            'saveAiQuestion',
            aiQuestions.value[currentAiLoopIdx.value - 1],
            answerValue,
            currentAiLoopIdx.value
        )
    }

    if (
        aiQuestions.value.length > maxAiQuestions.value ||
        isFinalAiQuestion.value
    ) {
        aiQuestions.value.pop()
        emit('callNext')
        return
    }

    const currentAiLoop =
        currentAiLoopIdx.value > 0
            ? [
                  {
                      question: aiQuestions.value[currentAiLoopIdx.value - 1],
                      answer: aiAnswers.value[currentAiLoopIdx.value - 1],
                  },
              ]
            : []

    const updatedContext: CurrentAnswer[] = [
        ...currentSurveyContext.value,
        ...currentAiLoop,
    ]
    currentSurveyContext.value = updatedContext

    const previewParams = {
        isPreview: props.isPreview,
        surveyScore: props.surveyParams.answer,
    }

    try {
        const { data } = await getAiQuestion(
            props.surveyParams.slug,
            updatedContext,
            previewParams
        )
        if (data.success) {
            isFinalAiQuestion.value = data.result.final_question
            aiQuestions.value.splice(
                aiQuestions.value.length - 1,
                1,
                data.result.question
            )
        } else {
            handleAiQuestionError(data)
            return
        }
    } catch (e) {
        handleAiQuestionError(e)
        return
    }
    isLoading.value = false
}

const handleAiQuestionError = (error) => {
    console.error(
        'Error generating AI question. Moving on with the survey.',
        error
    )
    aiQuestions.value.pop()
    emit('callNext')
}

const submitReplyText = (evt) => {
    evt.preventDefault()
    aiAnswers.value.push(currentAiAnswer.value)
    currentAiAnswer.value = ''

    getNextAiQuestion()
}

const onKeyPress = (evt) => {
    if (evt.keyCode === 13 && evt.shiftKey) {
        submitReplyText(evt)
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_autoexpand_height = _resolveDirective("autoexpand-height")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiQuestions.value, (question, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "survey-ai"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.avatarSrc && currentAiLoopIdx.value === idx)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.avatarSrc,
                  alt: "Avatar"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["survey-ai--say--bubble", { active: currentAiLoopIdx.value === idx }])
          }, [
            (isLoading.value && currentAiLoopIdx.value === idx)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(question), 1))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!aiAnswers.value[idx] && !isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentAiAnswer).value = $event)),
                  autofocus: "",
                  class: "survey-ai--receive--input",
                  onKeypress: onKeyPress
                }, null, 544), [
                  [_vModelText, currentAiAnswer.value],
                  [_directive_autoexpand_height]
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "survey-ai--receive--button",
                  disabled: !currentAiAnswer.value,
                  onClick: submitReplyText
                }, _hoisted_12, 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true),
          (aiAnswers.value[idx])
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(aiAnswers.value[idx]), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})